function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPnc = function SvgPnc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 26",
    style: {
      enableBackground: "new 0 0 40 26"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ee7623"
    },
    d: "M0 0h40v26H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.98 15.47c1.17 0 2.21-.065 2.99-.26-1.56.91-4.745 2.795-10.92 6.37l-.325.195c-1.105.65-2.34.715-2.86.195-.715-.715-.325-2.47.975-4.745l1.17-2.145c.195.26.585.455 1.04.455h7.995v-.065h-.065zm-7.085-5.655c.195-.455.585-.65.91-.715l-1.17-2.145C17.27 4.68 16.035 3.51 15.06 3.77c-.78.195-1.3 1.3-1.3 2.6v.455c-.065 7.15 0 10.79 0 12.61v.065c.195-.78.65-1.69 1.17-2.73l3.965-6.955zm10.01.78-.325-.195c-6.11-3.575-9.295-5.46-10.92-6.305.585.585 1.105 1.43 1.755 2.405l4.03 6.89c.195.455.26.78.13 1.105h2.47c2.6 0 4.29-.585 4.615-1.56.065-.65-.65-1.625-1.755-2.34z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgPnc;